import { Model } from "@interfaces/model.interface";
import { Part } from "@interfaces/models/part.interface";

export interface ProductionToolPart extends Model {
	isActive: boolean;
	part?: Part;
	partId: number;
	productionToolId: number;
	routerStage: number;
}

export class ProductionToolPart implements ProductionToolPart {
	constructor(data?: Partial<ProductionToolPart>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}